import React, { useState } from "react";
import { MdOutlineDateRange } from "react-icons/md";
import DatePicker from 'react-date-picker';
import "./style.scss";

type Props = {
  title: string;
  isAllowed: boolean;
  data: Date | undefined;
  updateData: (val: Date) => void;
};

export const ProfileDatePicker: React.FC<Props> = ({
  title,
  isAllowed,
  data,
  updateData,
}) => {
  const [date, setDate] = useState<any>(data);

  const handleOnChange = (selectedDate) => {
    updateData(selectedDate);
    setDate(selectedDate);
  }

  return (
    <div className="profile-input-container">
      <span>{title}</span>
      <div className={isAllowed ? 'profile-input-date' : 'profile-input-date profile-input-date-disabled'}>
        <DatePicker
          value={date}
          onChange={handleOnChange}
          disabled={!isAllowed}
          format="yyyy-MM-dd"
          calendarIcon={<MdOutlineDateRange />}
          clearIcon={null}
        />
      </div>
    </div>
  );
};
